import dynamic from "next/dynamic";
import BoardTabsConfig from "./board-tabs-config";
import BoardTabsAdvancedConfig from "./board-tabs-advanced-config";
const BoardTabsComponent = dynamic(()=>import("./board-tabs-component"));
export default {
    BoardTabsComponent,
    BoardTabsConfig,
    BoardTabsAdvancedConfig
};
